import React from "react";
import ReactDOM from "react-dom";
import { useLocation } from "react-router";

import Loader from "../../Loader";
import "../styles/default.scss";

export const AUTH_TOKEN_FOR_LOGIN_SEARCH_PARAM_NAME = "auth_token_for_login";

const AuthTokenForLoginWrapper = ({ children, location: locationProp }) => {
  const routerLocation = useLocation();
  const location = locationProp || routerLocation;

  const showOverlay =
    location?.search?.includes(AUTH_TOKEN_FOR_LOGIN_SEARCH_PARAM_NAME) ?? false;

  const overlay = showOverlay ? (
    <div
      className="auth-token-for-login-overlay"
      aria-busy="true"
      aria-live="polite"
    >
      <Loader />
    </div>
  ) : null;

  return (
    <>
      {children}
      {overlay && typeof document !== "undefined"
        ? ReactDOM.createPortal(overlay, document.body)
        : null}
    </>
  );
};

export default AuthTokenForLoginWrapper;
